// export const local_url = 'http://192.168.124.122:3001';


// export const local_url = 'http://18.61.70.28';

export const local_url = 'https://retailUAT.abisaio.com:9001';


export const web_hook = 'https://horeca.sthanave.com'


export const local_signage = 'https://retailuat.abisibg.com';



// export const local_signage = 'https://tpapi.abisaio.com:3060';

// export const web_hook = 'https://horeca-crm-backend.abisibg.com'

// export const local_url = 'https://ibretailapi.abisaio.com';